// Bingo — eigen scherm. Player-picker, scores, 16 tegels (zie content).

import { setTitle } from '../main.js'
import { icon } from '../icons.js'
import { getStore, setGameState } from '../store.js'
import { setState } from '../api.js'
import { esc, renderPlayerPick, renderScoresStrip, wirePlayerPick, showToast } from './_shared.js'

function renderGrid(ctx) {
  const store = getStore()
  const claims = store.game.bingo
  const tiles = ctx.data.bingo ?? []
  if (!tiles.length) return `<p class="empty">Nog geen bingo-tegels.</p>`
  return `
    <div class="bingo-grid bingo-grid-${tiles.length}">
      ${tiles.map(t => {
        const claimedBy = claims[t.id]
        return `
          <button class="bingo-tile ${claimedBy ? 'claimed' : ''}" data-tid="${esc(t.id)}">
            <div class="b-label">${esc(t.label)}</div>
            ${t.description ? `<div class="e-meta" style="margin-top:4px">${esc(t.description)}</div>` : ''}
            ${claimedBy ? `<div class="b-claimed-by">${esc(claimedBy)} · ${t.points} pt</div>` : `<div class="b-claimed-by">${t.points} pt</div>`}
          </button>`
      }).join('')}
    </div>
  `
}

function wireTiles(root, ctx) {
  root.querySelectorAll('.bingo-tile').forEach(btn => {
    btn.addEventListener('click', async () => {
      const tid = btn.dataset.tid
      const store = getStore()
      const me = store.player.name
      if (!me) { showToast(root, 'Kies eerst wie je bent (bovenaan).', true); return }
      const current = store.game.bingo[tid]

      if (current && current !== me) {
        showToast(root, `Geclaimd door ${current} — je kunt het niet overnemen.`, true)
        return
      }
      if (current === me) {
        btn.classList.add('confirm-unclaim')
        const label = btn.querySelector('.b-claimed-by')
        if (label) label.textContent = 'Tap nogmaals om te wissen'
        const handler = async () => {
          btn.removeEventListener('click', handler)
          btn.classList.remove('confirm-unclaim')
          const nextBingo = { ...store.game.bingo, [tid]: null }
          setGameState({ bingo: nextBingo })
          try { await setState({ bingo: nextBingo }) } catch (e) { showToast(root, `Niet opgeslagen: ${e.message}`, true) }
          root.querySelector('#bingo-grid-section').innerHTML = renderGrid(ctx)
          root.querySelector('#scores-section').innerHTML = renderScoresStrip(ctx)
          wireTiles(root, ctx)
        }
        btn.addEventListener('click', handler, { once: true })
        setTimeout(() => {
          btn.removeEventListener('click', handler)
          btn.classList.remove('confirm-unclaim')
          root.querySelector('#bingo-grid-section').innerHTML = renderGrid(ctx)
          wireTiles(root, ctx)
        }, 3000)
        return
      }

      const nextBingo = { ...store.game.bingo, [tid]: me }
      setGameState({ bingo: nextBingo })
      try { await setState({ bingo: nextBingo }) } catch (e) { showToast(root, `Niet opgeslagen: ${e.message}`, true) }
      showToast(root, `${me} claimt deze!`)
      root.querySelector('#bingo-grid-section').innerHTML = renderGrid(ctx)
      root.querySelector('#scores-section').innerHTML = renderScoresStrip(ctx)
      wireTiles(root, ctx)
    })
  })
}

export function renderBingo(root, ctx) {
  setTitle('')
  root.innerHTML = `
    <div class="page">
      <h1 class="title">Bingo</h1>
      <p class="subtitle">Spot het en claim punten</p>
      ${renderPlayerPick(ctx)}
      <div id="scores-section">${renderScoresStrip(ctx)}</div>
      <div id="bingo-grid-section">${renderGrid(ctx)}</div>
    </div>
  `
  wirePlayerPick(root, () => {
    root.querySelector('#scores-section').innerHTML = renderScoresStrip(ctx)
  })
  wireTiles(root, ctx)
}
